
























































































































































































































































































































































































































































































































































































































import { getProp, setProp } from '@shared/helpers/operators';
import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync, faPowerOff, faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { ActivitySession } from '@modules/activities/interfaces/activity-session';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import { v4 as uuidv4 } from 'uuid';
import ActivitySessionGameForm from '@activities/components/forms/activity-session-game-form/activity-session-game-form.vue';
import moment from 'moment';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Activity } from '@activities/interfaces/activity';
import AttendeeTableInput from '@shared/components/forms/inputs/attendee-table-input/attendee-table-input.vue';
import GameSessionsWeeklyCalendar from '@activities/components/calendars/game-sessions-weekly-calendar.vue';
import GameSummaryCard from '@activities/components/cards/game-summary-card/game-summary-card.vue';
import GameTripSummaryCard from '@activities/components/cards/game-trip-summary-card/game-trip-summary-card.vue';
import NotifySummonsAttendeeModal from '@activities/components/modals/notify-summons-attendee-modal/notify-summons-attendee-modal.vue';

library.add(faPowerOff, faToggleOff, faToggleOn, faSync);

@Component({
  name: 'bpc-activity-session-game-table',
  components: {
    'bpc-notify-summons-attendee-modal': NotifySummonsAttendeeModal,
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
    'bpc-game-sessions-weekly-calendar': GameSessionsWeeklyCalendar,
    'bpc-activity-session-game-form': ActivitySessionGameForm,
    'bpc-attendee-table-input': AttendeeTableInput,
    'bpc-game-summary-card': GameSummaryCard,
    'bpc-game-trip-summary-card': GameTripSummaryCard,
  },
})
export default class ActivitySessionGameTable extends mixins(AbstractTable) {
  declare $refs: AbstractTable['$refs'] & {
    sessionsWeeklyCalendar: InstanceType<typeof GameSessionsWeeklyCalendar> & {
      getAllSessionsOfTheWeek: () => Promise<void>;
    };
    stdCancelForm: InstanceType<typeof StdForm> & {
      formModel: any;
      formProvider: EntityFormProvider;
    };
    gameForm: InstanceType<typeof ActivitySessionGameForm> & {
      formModel: any;
      formProvider: EntityFormProvider;
      onSaveGameSession(): Promise<BPCGenericApiResponse>;
      saveEntity(): Promise<BPCGenericApiResponse>;
    };
    tableInputGameAttendees: InstanceType<typeof AttendeeTableInput> & {
      getEntities(): void;
    };
    tableInputComingAttendees: InstanceType<typeof AttendeeTableInput> & {
      getEntities(): void;
    };
  };
  @Prop({ type: String, default: 'cancel-activity-session-game' })
  readonly cancelFormConfigName: string;
  @Prop({ type: String, default: 'edit' }) readonly editFormConfigName: string;
  @Prop({ type: String, default: 'calendar' }) readonly typeOfDisplay: string;
  @Prop(Object) readonly activity: Activity;
  @Prop({ type: Array, default: () => [''] })
  declare readonly filtersExcluded: string[];
  @Prop({ type: Boolean, default: true }) readonly showCalendarActivityFilter: boolean;
  @Prop({ type: Boolean, default: true }) readonly showCalendarTeamFilter: boolean;
  @Prop({ type: Boolean, default: true }) readonly showResponsibleFilter: boolean;
  @Prop(Object) readonly externalFormModel: object;

  mounted() {
    this.$root.$on('saved-on-change-from-table', val => {
      this.refreshSummonsData();
    });
  }

  destroyed() {
    super.destroyed();
    this.$off('saved-on-change-from-table');
  }

  public entity: ActivitySession = null;
  public entityName = 'activity-session';
  public pluralEntityName = 'activity-sessions';
  public permissionEntityNameToUse = 'activity_sessions';
  public selectedRowEntity = null;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  //DATA
  timestamp = moment().unix();
  calendarView = true;
  tableView = false;
  showNotifySummonModal: boolean = false;
  refreshTiles: string = uuidv4();
  //Bulk trash modal data
  showBulkMoveToTrashModal = false;
  //Bulk recover modal data
  showBulkRecoverModal = false;
  // Bulk cancel modal data
  public isProcessing: boolean = false;
  public eventsSuccess = [];
  public eventsError = [];
  public requestSent: boolean = false;
  public processAll: boolean = false;
  public reportPerPage: number = 20;
  public reportCurrentPage: number = 1;
  dataToShowInBulkReports = [['code', 'name', 'date']];
  sendEmailOptionSelected: boolean = this.defaultSendBookingEventChangeEmail;
  public initializedFormModel = null;

  public customPageActions = {
    create: {
      activated: true,
      type: 'action',
      icon: 'plus',
      variant: 'success',
      text: 'create-new',
      show: true,
      event: 'create',
      selectElements: false,
      tag: 'right',
      permissions: ['store'],
    },
    bulkCancel: {
      activated: false,
      type: 'action',
      icon: 'ban',
      variant: 'danger',
      text: 'cancel',
      event: 'bulk-cancel',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_cancel'],
      show: false,
    },
  };

  get defaultSendBookingEventChangeEmail(): boolean {
    return !!this.$store.getters['centerSettings/centerSettings']?.admin_send_session_updated_email;
  }

  get showSendEmailOption(): boolean {
    let showModalUpdate = false;
    // Check if the date of time_range has been changed
    if (this.initializedFormModel && this.$refs.gameForm?.formModel) {
      if (
        JSON.stringify(
          `${this.initializedFormModel.date}${this.initializedFormModel.start_time}${this.initializedFormModel.end_time}`,
        ) !==
        JSON.stringify(
          `${this.$refs.gameForm?.formModel.date}${this.$refs.gameForm?.formModel.start_time}${this.$refs.gameForm?.formModel.end_time}`,
        )
      ) {
        showModalUpdate = true;
      }
    }
    return (
      this.$store.getters['centerSettings/centerSettings']?.send_session_updated_email &&
      showModalUpdate
    );
  }

  //METHODS
  async onSaveGameSession(): Promise<BPCGenericApiResponse> {
    return await this.$refs.gameForm.onSaveGameSession();
  }

  // Bulk soft delete modal (move to trash)
  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }
  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }
  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    if (this.tableView) {
      this.$refs.provider.getEntities();
    }
  }

  // Bulk restore modal (recover)
  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }
  onCLoseBulkRecover() {
    this.showBulkRecoverModal = false;
  }
  onSuccessBulkRecover() {
    if (this.tableView) {
      this.$refs.provider.getEntities();
    }
  }

  // Add summon modal
  onOpenSummonModal() {
    this.showNotifySummonModal = true;
  }

  onCloseAddSummonModal() {
    this.showNotifySummonModal = false;
  }

  refreshSummonsData() {
    this.refreshTiles = uuidv4();
    this.$refs.tableInputGameAttendees?.getEntities();
    this.$refs.tableInputComingAttendees?.getEntities();
  }

  // Page actions
  customOnPageAction($event: string) {
    switch ($event) {
      case 'bulk-cancel':
        this.onOpenBulkCancelModal();
        break;
    }
  }

  extendUpdatePageActions() {
    if (this.config) {
      for (const activatedPageAction of this.config.data.activatedPageActions) {
        if (this.customPageActions[activatedPageAction]) {
          this.customPageActions[activatedPageAction].activated = true;
        }
      }
    }

    this.customPageActions.bulkCancel.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      this.$refs.provider.queryConfig.params.status !== 'cancelled' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;
  }

  // Row actions
  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'cancel':
        this.onOpenCancelModal($event.item.item);
        break;
    }
  }

  extendUpdateRowActions(entity: any) {
    const hasCancelPermission = this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
      'cancel',
    );

    entity.actions.cancel.show = entity.can_be_cancelled && hasCancelPermission;
    return null;
  }

  onEditSessionFromCalendar(e) {
    const activity = getProp(e, 'extendedProps.activity');
    this.$emit('edit-from-calendar', activity);
    e['activity_id'] = activity.id;
    this.$nextTick().then(() => {
      this.onEdit({ item: e });
    });
  }

  presetVariables = {};

  onDateSelectedFromCalendar(e) {
    this.presetVariables = {
      date: e.date,
      start_time: e.time_range.start_time,
      end_time: e.time_range.end_time,
    };
    this.$emit('create-from-calendar');
    this.$nextTick().then(() => {
      this.onNew();
    });
  }

  onModelLoaded(event) {
    const formModel = event;
    this.initializedFormModel = JSON.parse(JSON.stringify(formModel));
    const newModel = {
      ...formModel,
      ...this.presetVariables,
    };
    this.$set(this.$refs.gameForm, 'formModel', newModel);
    this.presetVariables = {};
    this.$emit('model-loaded', newModel);
  }

  setStdFormData(index, value) {
    setProp(this.$refs.gameForm.formModel, index, value);
  }

  changeView(view: string) {
    if (view === 'table') {
      this.calendarView = false;
      this.tableView = true;
    }

    if (view === 'calendar') {
      this.tableView = false;
      this.calendarView = true;
    }
    this.cleanUrlParams();
    this.$emit('view-changed');
  }

  async queryParamsChangedFromCalendar(params) {
    if (this.calendarView) {
      await this.$router.push({ query: params }).catch(e => {
        return null;
      });
    }
  }

  cleanUrlParams() {
    this.$router.push({ query: {} }).catch(e => {
      return null;
    });
  }

  onFormSave() {
    if (this.showSendEmailOption) {
      this.$bvModal.show(`confirmation-update-modal-session`);
    } else {
      this.$refs.gameForm.saveEntity();
    }
  }

  onFormSaved() {
    if (this.nextAction === 'new') {
      this.setEntityAttributesAfterSave();
      if (this.tableView) {
        this.$refs.provider.getEntities();
      }
    } else {
      this.onFormClose();
      if (this.calendarView) {
        this.$refs.sessionsWeeklyCalendar.getAllSessionsOfTheWeek();
      }
      if (this.tableView) {
        this.$refs.provider.getEntities();
      }
    }
  }

  refreshCalendar() {
    if (this.calendarView) {
      this.$refs.sessionsWeeklyCalendar.getAllSessionsOfTheWeek();
    }
  }

  refreshTable() {
    if (this.tableView) {
      this.$refs.provider.getEntities();
    }
  }

  onOpenCancelModal(entity) {
    this.selectedRowEntity = entity;
    this.$bvModal.show('cancel-modal');
  }

  onCloseCancelModal() {
    this.selectedRowEntity = null;
    this.$bvModal.hide('cancel-modal');
  }

  onOpenBulkCancelModal() {
    // TODO if only one is selected, call onOpenCancelModal with the selected entity
    this.resetBulkCancelModal();
    this.$bvModal.show('bulk-cancel-modal');
  }

  onCloseBulkCancelModal() {
    this.resetBulkCancelModal();
    this.$bvModal.hide('bulk-cancel-modal');
  }

  resetBulkCancelModal() {
    this.requestSent = false;
    this.isProcessing = false;
    this.eventsSuccess = [];
    this.eventsError = [];
    this.processAll = false;
  }

  onSuccessBulkCancel() {
    if (this.tableView) {
      this.$refs.provider.getEntities();
    }
    if (this.calendarView) {
      this.refreshCalendar();
    }
  }

  onConfirmCancelOne() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-sessions');
    const relativePath = '/' + this.selectedRowEntity.id + '/cancel';
    this.$bpcApi
      .post(basePath + relativePath, {
        id: this.selectedRowEntity.id,
        cancel_reason: this.$refs.stdCancelForm.formModel['cancel_reason'],
        cancel_reason_description: this.$refs.stdCancelForm.formModel['cancel_reason_description'],
        cancel_orders: this.$refs.stdCancelForm.formModel['cancel_orders'],
        notify_by_email:
          'notify_by_email' in this.$refs.stdCancelForm.formModel
            ? this.$refs.stdCancelForm.formModel['notify_by_email']
            : true,
      })
      .subscribe(
        res => {
          this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
          if (this.tableView) {
            this.$refs.provider.getEntities();
          }
        },
        () => {
          this.$bpcMessage.showErrorMessage({
            text: 'global.generic.error_form_action',
          });
        },
        () => {
          this.selectedRowEntity = null;
          this.$bvModal.hide('cancel-modal');
          this.onFormClose();
          this.refreshCalendar();
        },
      );
  }

  onConfirmCancelBulk() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('activity-sessions');
    const relativePath = '/bulk-cancel';
    const sessionCode = this.generateSessionCode();
    this.listenToWebsocketCancelChannel(sessionCode);
    this.requestSent = true;

    this.$bpcApi
      .post(basePath + relativePath, {
        ids: this.selection,
        filters: this.filters,
        search_and_order: this.searchAndOrderQueryParams,
        process_all: this.processAll,
        session_code: sessionCode,
        cancel_reason: this.$refs.stdCancelForm.formModel['cancel_reason'],
        cancel_reason_description: this.$refs.stdCancelForm.formModel['cancel_reason_description'],
        cancel_orders: this.$refs.stdCancelForm.formModel['cancel_orders'],
        notify_by_email:
          'notify_by_email' in this.$refs.stdCancelForm.formModel
            ? this.$refs.stdCancelForm.formModel['notify_by_email']
            : true,
        // ...this.extraData,
      })
      .subscribe(
        res => {
          // this.$emit('request-sent');
        },
        error => {
          // this.$emit('error-sending-request');
          console.log(error);
          this.$bpcMessage.showErrorMessage({
            text: 'global.generic.error_form_action',
          });
          this.$bpcEcho.leaveBulkCancelChannel(sessionCode);
          this.resetBulkCancelModal();
        },
      );
  }

  listenToWebsocketCancelChannel(sessionCode) {
    this.isProcessing = true;
    this.$bpcEcho
      .listenBulkCancelChannel(sessionCode)
      .listen('.BPC\\Core\\Events\\EntitiesCancelled', data => {
        if (data.result?.entities_processed?.length) {
          this.$bpcMessage.showInfoMessage({
            text: 'global.actions.bulk_cancel.entities_cancelled',
          });
        }
        this.isProcessing = false;
        this.onSuccessBulkCancel();
        this.$bpcEcho.leaveBulkCancelChannel(sessionCode);
      })
      .listen('.BPC\\Core\\Events\\EntityCancelled', data => {
        this.eventsSuccess.push(data);
      })
      .listen('.BPC\\Core\\Events\\ErrorCancellingEntity', data => {
        this.eventsError.push(data);
      });
  }

  generateSessionCode(): string {
    return `cancel-${this.tenantId}-${uuidv4()}`;
  }

  onCreateAttendee() {
    this.$root.$emit('triggerActionInEntityTableInput', {
      fieldName: 'activitySessionAttendees',
      action: 'create',
    });
  }

  //COMPUTED
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  get activityId(): number {
    return this.activity?.id;
  }

  get pageActions() {
    // Invert the order
    return {
      ...this.customPageActions,
      ...this.defaultPageActions,
    };
  }

  get reportRows() {
    return this.eventsError.length;
  }
  get reportCurrentList() {
    const start = this.reportCurrentPage * this.reportPerPage - this.reportPerPage;
    const end = start + this.reportPerPage;
    return this.eventsError.slice(start, end);
  }

  public get confirmationUpdateModalTitle() {
    return this.$t('global.modals.update-session.title');
  }

  public get confirmButtonText() {
    return this.$t('global.buttons.confirm');
  }

  public get cancelButtonText() {
    return this.$t('global.buttons.cancel');
  }

  public get sendEmailOptionsLabel() {
    return this.$t('global.modals.update-booking-event.send_email.label');
  }

  get activityType(): string {
    return this.activity?.activity_type;
  }

  get entityId(): number | string {
    return this.entity ? this.entity.id : null;
  }

  confirmUpdateEvent() {
    this.$set(this.$refs.gameForm.formModel, 'notify_by_email', this.sendEmailOptionSelected);
    this.$refs.gameForm.saveEntity();
  }

  onFormClose() {
    this.showForm = false;
    this.showDrawerSection = false;
    this.i++;
    this.isSavingForm = false;
    this.refreshTable();
    this.refreshCalendar();
  }

  onEdit(e, disabled = false) {
    if (this.isInput) {
      this.loadActivityToUseAsInput(e.item.activity_id);
      this.entity = e.item;
      this.showForm = true;
      this.showDrawerSection = true;
      setTimeout(() => {
        this.disabledForm = disabled;
      });
    } else if (!this.emitOnEdit) {
      this.entity = e.item;
      this.showForm = true;
      this.showDrawerSection = true;
      setTimeout(() => {
        this.disabledForm = disabled;
      });
    } else {
      this.$emit('on-edit', e);
    }
  }

  loadActivityToUseAsInput(activityId) {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('bpc-activity');
    const url = `${basePath}/${activityId}`;
    this.$bpcApi.get(url, {}).subscribe(res => {
      this.$emit('set-activity', res.data);
    });
  }

  /* Lifecycle hooks */

  // created() {}
  created() {
    if (this.typeOfDisplay === 'table') {
      this.tableView = true;
      this.calendarView = false;
    } else {
      this.calendarView = true;
      this.tableView = false;
    }
  }
  // updated() {}
  // destroyed() {}
}
